// extracted by mini-css-extract-plugin
export default {"glassMenu":"glassStyles_glassMenu__xNyx5"};